import { render, staticRenderFns } from "./SuggestedPrompts.vue?vue&type=template&id=ed132ce8&scoped=true&lang=pug"
import script from "./SuggestedPrompts.js?vue&type=script&lang=js&external"
export * from "./SuggestedPrompts.js?vue&type=script&lang=js&external"
import style0 from "./SuggestedPrompts.vue?vue&type=style&index=0&id=ed132ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed132ce8",
  null
  
)

export default component.exports